import {createSelector} from 'reselect';
import {getSelectedDeliveryCountry, getSettings} from './selectors';

export default createSelector(
  [getSettings, getSelectedDeliveryCountry],
  (settings, country) => !!settings.should_pass_name_code_for_state_if_available?.includes(country),
);
